import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseButton from '../../components/atoms/CloseButton';
import GochiMenuDetailTableGroupV2 from '../../components/molecules/GochiMenuDetailTableGroupV2';

const styles = {
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 48,
    overflow: 'scroll',
    outline: 'none',
    borderRadius: 4
  },
  margin: {
    margin: '20px 0 0 0'
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginTop: 16
  },
  tableContainer: {
    marginTop: 45
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, detail, updateOpenDetailModal }) => {
  const closeAction = () => updateOpenDetailModal(false);
  return (
    <div className={classes.root}>
      <Typography className={classes.title}>メニュー詳細</Typography>
      <div className={classes.tableContainer}>
        <GochiMenuDetailTableGroupV2
          menuName={detail.menuName}
          price={detail.price}
          taxTypeStr={detail.taxTypeStr}
          reducedTaxTypeStr={detail.reducedTaxTypeStr}
          description={detail.description}
          tags={detail.tags}
          comboMenu={detail.comboMenu}
          priceCombo={detail.priceCombo}
          quantityRelease={detail.quantityRelease}
          quantityPromotion={detail.quantityPromotion}
          promotionDescription={detail.promotionDescription}
          usageLimit={detail.usageLimit}
          expiration={detail.expiration}
          expirationEndDate={detail.expirationEndDate}
          image={detail.image}
          createdAt={detail.createdAt}
          updatedAt={detail.updatedAt}
          shopId={detail.shopId}
          shopName={detail.shopName}
          menuId={detail.menuId}
          subscription={detail.subscription}
          subscriptionIntervalCount={detail.subscriptionIntervalCount}
          subscriptionInterval={detail.subscriptionInterval}
          menuChildType={detail.menuChildType}
          shashokuOptionStr={detail.shashokuOptionStr}
          showHide={detail.showHide}
          genreName={detail.menuGenreName}
          situationNames={detail.menuSituationNames}
          userTargetNames={detail.menuUserTargetNames}
          menuLimitTotal={detail.menuLimitTotal}
          usageType={detail.usageType}
          taxType={detail.taxType}
        />
      </div>
      <div className={classes.tableContainer} style={{ marginBottom: 16 }}>
        <CloseButton onClickAction={closeAction} />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
